import { SchedulingErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Set } from '~commonInfra/utils/Set';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Formatters, Messages } from '../../codegen/Localize';
import { ActionHelpers, standardActionErrorMsg, standardActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { FlowContentType } from '../../spacesPlatform/models/ContentTypes';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { RunFlowTasks } from '../resources/RunFlowTasks';

export namespace DeleteRunFlowTasksAction {

  export function dialog(runFlowTaskInfos: Set<RunFlowTaskInfo>): Promise<IResult> {
    let description: string;
    if (runFlowTaskInfos.size() === 1) {
      const task = runFlowTaskInfos.first();
      description = Messages.confirmDeleteRunFlowTask({ FLOW_NAME: L10n.elideIfLong(task.flow.name) });
    } else {
      description = Messages.confirmDeleteRunFlowTasks({
        ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size())
      });
    }

    const confirmationDialog = openReactConfirmationDialog<Set<RunFlowTaskInfo>, IResult>({
      title: Messages.deleteMessage(),
      message: description,
      paramsForAction: runFlowTaskInfos,
      actionName: Messages.confirmDeleteButton({ ITEM_COUNT: runFlowTaskInfos.size(), ITEM_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()) }),
      isActionDelete: true,
      dialogWidth: TabDialogWidth.width375px,
      action: action
    });
      return Promise.resolve(confirmationDialog.result);
  }

  function action(runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    return RunFlowTasks.del(runFlowTaskInfos.keys())
      .then(result => ActionHelpers.displayStandardToastsForResult(
        runFlowTaskInfos,
        result,
        {
          success: standardActionSuccessMsg(Messages.deleteRunFlowTasksSuccess),
          error: standardActionErrorMsg(Messages.deleteRunFlowTasksError),
        },
        (errorItem: IErrorItem<RunFlowTaskInfo>) => {
          return errorDetailFor(errorItem);
        }
      ));
  }

  function urlFor(errorItem: IErrorItem<RunFlowTaskInfo>): string {
    return ContentUrlForItem(errorItem.item.flow, FlowContentType);
  }

  function errorMessageFor(errorItem: IErrorItem<RunFlowTaskInfo>) {
    switch (errorItem.error.code) {
      case SchedulingErrorCode.SchedulingTaskNotFound:
        return Messages.errorRunFlowTaskNotFound({
          FLOW_NAME: L10n.elideIfLong(errorItem.item.flow.name),
          SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
        });
      default:
        return Messages.errorUnknown();
    }
  }

  export function errorDetailFor(errorItem: IErrorItem<RunFlowTaskInfo>): IErrorDetail {
    const itemName = errorItem.item.flow.name;
    const errorMessage = errorMessageFor(errorItem);
    return {
      itemName: itemName,
      itemUrl: urlFor(errorItem),
      errorMessage: errorMessage
    };
  }

}
